import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Entry } from "../../redux/entrySlice";
import TextInput from "../TextField/TextField";
import styles from "./SuspendUserModal.module.scss";

const SuspendUserModal = ({ show, handleClose, userId, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const {
    register,
    reset,
    setFocus,
    getValues,
    setError: setFieldError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      reason: "",
    },
  });

  const handleCloseModal = () => {
    reset();
    clearErrors();
    setError(null);
    handleClose();
  };

  const validateReason = () => {
    clearErrors("reason");
    const trimmedReason = (getValues("reason") || "").trim();

    if (!trimmedReason) {
      setFieldError("reason", {
        type: "manual",
        message: "Reason is required.",
      });
      setFocus("reason");
      return null;
    }

    if (trimmedReason.length < 3) {
      setFieldError("reason", {
        type: "manual",
        message: "Reason must be at least 3 characters.",
      });
      setFocus("reason");
      return null;
    }

    if (trimmedReason.length > 500) {
      setFieldError("reason", {
        type: "manual",
        message: "Reason must not exceed 500 characters.",
      });
      setFocus("reason");
      return null;
    }

    return trimmedReason;
  };

  const handleSuspendClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const trimmedReason = validateReason();
    if (!trimmedReason) {
      return;
    }

    setSubmitting(true);
    setError(null);

    const actionData = {
      actionUrl: `user/${userId}/suspend`,
      actionMethod: "patch",
      apiData: {
        suspendReason: trimmedReason,
      },
    };

    dispatch(Entry(actionData))
      .then((resp) => {
        setSubmitting(false);
        if (resp.payload.code === 200) {
          toast.success("User suspended successfully");
          onSuccess?.();
          handleCloseModal();
        } else {
          setError(resp.payload.message || "Error suspending user");
          toast.error(resp.payload.message || "Failed to suspend user");
        }
      })
      .catch((err) => {
        setSubmitting(false);
        setError("Network error. Please try again.");
        toast.error("Network error suspending user");
        console.error("Suspend User Error:", err);
      });
  };

  return (
    <Modal show={show} onHide={handleCloseModal} centered>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Suspend User</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div>
          <TextInput
            className={`${styles.inputbox} ${errors.reason ? styles.inputError : ""}`}
            labelstyle={styles.formlabel}
            label="Reason"
            fieldName="reason"
            placeHolder="Enter reason for suspension"
            register={register}
            errors={errors}
            isRequired
            mandatory
            minimLength={3}
            maximLength={500}
          />
          {error && <div className={styles.errorMessage}>{error}</div>}
          <div className={styles.modalFooter}>
            <Button
              variant="primary"
              type="button"
              className={styles.actionBtn}
              onClick={handleSuspendClick}
              disabled={submitting}
            >
              {submitting ? "Suspending..." : "Suspend User"}
            </Button>
            <Button
              variant="primary"
              type="button"
              className={styles.actionBtn}
              onClick={handleCloseModal}
              disabled={submitting}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuspendUserModal;
